import Error from '../../error/components/Error';

import activationSuccessSvg from '../../../assets/images/ActivationSuccess.svg';

export const activationSuccess = {
  firstLevel: () => <Error
    image={activationSuccessSvg}
    meta={{
      description: 'client_accountActivated',
      keywords:    'default_meta_keywords',
      title:       'client_accountActivated_steelline',
    }}
    title={'client_accountActivated'}
  />,
};